import React, { useCallback, useEffect, useState } from 'react';
import { Search, Phone, Loader2, Check, X, Trash2 } from 'lucide-react';
import client from '../lib/api';
import { useToast } from '../hooks/use-toast';
import ConfirmDialog from './components/ConfirmDialog';
import { AdminError } from './components/PageState';

const statusOpts = [
  { id: 'all', label: 'Tümü' },
  { id: 'pending', label: 'Bekliyor', color: 'yellow' },
  { id: 'called', label: 'Aranmış', color: 'blue' },
  { id: 'done', label: 'Tamamlandı', color: 'green' },
  { id: 'rejected', label: 'Reddedildi', color: 'red' },
];

const CallRequests = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('all');
  const [error, setError] = useState('');
  const [confirmation, setConfirmation] = useState(null);
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try { const { data } = await client.get('/admin/callbacks', { params: { status: status !== 'all' ? status : undefined } }); setItems(data.items || []); } catch (requestError) {
      setError(requestError.response?.data?.detail || 'Talepler yüklenemedi');
    }
    finally { setLoading(false); }
  }, [status]);
  useEffect(() => { load(); }, [load]);

  const update = async (id, patch) => {
    try { await client.patch(`/admin/callbacks/${id}`, patch); toast({ title: 'Güncellendi' }); load(); }
    catch (e) { toast({ title: 'Hata', description: e.message }); }
  };
  const executeConfirmation = async () => {
    if (!confirmation) return;
    setBusy(true);
    try {
      if (confirmation.action === 'delete') {
        await client.delete(`/admin/callbacks/${confirmation.item.id}`);
      } else {
        await update(confirmation.item.id, { status: 'rejected' });
      }
      setConfirmation(null);
      await load();
    } catch (requestError) {
      toast({ title: 'İşlem başarısız', description: requestError.response?.data?.detail });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'rgba(56,189,248,0.15)', color: 'var(--v2-info, #38bdf8)' }}><Search size={18} /></div>
        <div>
          <h1 className="text-xl font-bold">Beni Ara Talepleri</h1>
          <p className="text-xs text-slate-400">Ziyaretçilerden gelen geri arama istekleri</p>
        </div>
      </div>

      <div className="flex gap-2 flex-wrap mb-4">
        {statusOpts.map((s) => (
          <button key={s.id} onClick={() => setStatus(s.id)} className={`admin-tab ${status === s.id ? 'active' : ''}`}>{s.label}</button>
        ))}
      </div>

      <div className="admin-card overflow-hidden">
        {loading ? (
          <div className="p-10 text-center"><Loader2 className="inline animate-spin text-cyan-400" /></div>
        ) : error ? (
          <AdminError message={error} onRetry={load} />
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-slate-500">Talep yok</div>
        ) : (
          <div className="overflow-x-auto">
          <table className="admin-table w-full min-w-[900px]">
            <thead><tr><th>AD</th><th>TELEFON</th><th>KONU</th><th>NOT</th><th>DURUM</th><th>TARİH</th><th>İŞLEMLER</th></tr></thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id}>
                  <td className="font-semibold">{c.name}</td>
                  <td className="text-cyan-400"><a href={`tel:${c.phone}`} className="hover:underline flex items-center gap-1"><Phone size={12} /> {c.phone}</a></td>
                  <td>{c.subject || '-'}</td>
                  <td className="text-xs text-slate-400 max-w-[200px] truncate">{c.note || '-'}</td>
                  <td><span className={`badge-pill ${c.status === 'pending' ? 'badge-yellow' : c.status === 'called' ? 'badge-blue' : c.status === 'done' ? 'badge-green' : 'badge-red'}`}>{c.status}</span></td>
                  <td className="text-xs text-slate-400">{new Date(c.created_at).toLocaleString('tr-TR')}</td>
                  <td>
                    <div className="flex gap-1">
                      <button title="Aranmış olarak işaretle" onClick={() => update(c.id, { status: 'called' })} className="icon-btn edit"><Phone size={12} /></button>
                      <button title="Tamamlandı" onClick={() => update(c.id, { status: 'done' })} className="icon-btn plus"><Check size={12} /></button>
                      <button title="Reddet" onClick={() => setConfirmation({ action: 'reject', item: c })} className="icon-btn minus"><X size={12} /></button>
                      <button title="Sil" onClick={() => setConfirmation({ action: 'delete', item: c })} className="icon-btn ban"><Trash2 size={12} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
      <ConfirmDialog
        open={Boolean(confirmation)}
        title={confirmation?.action === 'delete' ? 'Talebi sil' : 'Talebi reddet'}
        description={confirmation
          ? `${confirmation.item.name} adına açılan geri arama talebi ${confirmation.action === 'delete' ? 'kalıcı olarak silinecek' : 'reddedildi olarak işaretlenecek'}.`
          : ''}
        confirmLabel={confirmation?.action === 'delete' ? 'Sil' : 'Reddet'}
        tone="danger"
        busy={busy}
        onCancel={() => !busy && setConfirmation(null)}
        onConfirm={executeConfirmation}
      />
    </div>
  );
};

export default CallRequests;
